import React from 'react';
import SocialShareButtons from './SocialShareButtons';
import { SHOP_PUBLIC_ENABLED } from '../utils/shopPublic';

const Footer: React.FC = () => {
  const siteUrl = 'https://esoteric.pl/';
  const shareText = 'Odkryj świat ezoteryki na esoteric.pl!';

  return (
    <footer className="mt-auto w-full py-10 px-4 sm:px-6 lg:px-8 mx-auto bg-mystic-box border-t border-gray-800 text-gray-400">
      {/* Top section with links */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 mb-10">
        
        {/* Col 1: Informacje prawne */}
        <div>
          <a href="/" aria-label="esoteric.pl" className="inline-flex items-center gap-2 mb-4">
            <img
              src="/favicon.svg"
              alt=""
              className="h-10 w-10"
              width="40"
              height="40"
              loading="lazy"
              aria-hidden
            />
            <img
              src="https://assets.esoteric.pl/img/logo-white.svg"
              alt="esoteric.pl"
              className="h-5 w-auto"
              width="135"
              height="20"
              loading="lazy"
            />
          </a>
          <div className="space-y-3 text-sm">
            <p>Esoteric.pl to portal ezoteryczny, w którym znajdziesz treści do codziennej praktyki i pracy z energią. Prowadzimy też blog ezoteryczny z konkretnymi wskazówkami, które łatwo wdrożyć.</p>
            <p>To miejsce daje więcej niż same artykuły. Sprawdzisz tu horoskop, horoskop na dziś, horoskop na jutro oraz sprawdzisz jaka jest aktualna faza ksiezyca. Znajdziesz też więcej treści o energii, intencji i świadomej praktyce.</p>
          </div>
        </div>

        {/* Col 2: Przydatne linki */}
        <div>
          <p className="font-bold text-white mb-4">Polecane kategorie</p>
          <div className="space-y-3 text-sm">
            {SHOP_PUBLIC_ENABLED && (
              <>
                <p><a className="hover:text-white transition-colors" href="/sklep">Świece naturalne</a></p>
                <p><a className="hover:text-white transition-colors" href="/sklep">Kadziadła naturalne</a></p>
                <p><a className="hover:text-white transition-colors" href="/sklep">Rytuały</a></p>
                <p><a className="hover:text-white transition-colors" href="/sklep">Kamienie i Kryształy</a></p>
              </>
            )}
            <p><a className="hover:text-white transition-colors" href="/horoskop">Horoskop</a></p>
            <p><a className="hover:text-white transition-colors" href="/faza-ksiezyca">Faza księżyca</a></p>
            <p><a className="hover:text-white transition-colors" href="/blog">Blog ezoteryczny</a></p>
          </div>
        </div>

        {/* Col 3: Polecane kategorie */}
        <div>
          <p className="font-bold text-white mb-4">Dla ekspertów</p>
          <div className="space-y-3 text-sm">
            <p><a className="hover:text-white transition-colors" href="/kontakt">Opublikuj artykuł</a></p>
            <p><a className="hover:text-white transition-colors" href="/kontakt">Rejestracja eksperta</a></p>
          </div>
          <p className="font-bold text-white mb-4 mt-7">Przydatne linki</p>
          <div className="space-y-3 text-sm">
            <p><a className="hover:text-white transition-colors" href="/sekcja-prawna">Regulaminy serwisu</a></p>
            <p><a className="hover:text-white transition-colors" href="/sekcja-prawna?sekcja=polityka-prywatnosci">Polityka prywatnosci i RODO</a></p>
            <p><a className="hover:text-white transition-colors" href="/sekcja-prawna?sekcja=informacja-cookies-analityka">Informacja o cookies i analityce</a></p>
          </div>
        </div>
        
        {/* Col 4: Podmiot odpowiedzialny */}
        <div>
          <p className="font-bold text-white mb-4">Podmiot odpowiedzialny</p>
          <div className="space-y-3 text-sm">
            <p>esoteric sp. z o.o., ul. marszałkowska 58, 00-545 warszawa, nip: 7010833219</p>
            <p>mail: <a className="hover:text-white transition-colors" href="mailto:kontakt@esoteric.pl">kontakt@esoteric.pl</a></p>
          </div>
          <p className="font-bold text-white mb-4 mt-7">Pomoc</p>
          <div className="space-y-3 text-sm">
            <p><a className="hover:text-white transition-colors" href="/faq">Częste pytania / FAQ</a></p>
            <p><a className="hover:text-white transition-colors" href="/kontakt">Kontakt</a></p>
            <p><a className="hover:text-white transition-colors" href="/wspolpraca">Współpraca</a></p>
            <p><a className="hover:text-white transition-colors" href="/dla-influencerow">Dla influencerów</a></p>
          </div>
        </div>
      </div>

      {/* Bottom section with copyright and icons */}
      <div className="max-w-7xl mx-auto pt-8 mt-8 border-t border-gray-700 flex flex-col md:flex-row justify-between items-center gap-6">
        
        {/* Left Side: Copyright */}
        <div className="text-center md:text-left">
           <p className="text-sm">
                © {new Date().getFullYear()} esoteric.pl - portal ezoteryczny nr #1
           </p>
        </div>

        {/* Right Side: Icons */}
        <div className="flex flex-col items-center md:items-end gap-4">
            {/* Social Icons */}
            <SocialShareButtons
              shareUrl={siteUrl}
              shareText={shareText}
              className="justify-center md:justify-end"
            />
        </div>

      </div>
    </footer>
  );
};

export default Footer;